// ─── 공유 색상 상수 ───
// 상승·하락은 한국식: 상승 빨강 / 하락 파랑 (2026-10-06, 텔레그램 브리핑과 통일)
export const C = {
  up: "#f04452", down: "#3182f6", purple: "#a78bfa", yellow: "#f0c040",
  text: "var(--text)", muted: "var(--text-sub)", sub: "var(--text-inactive)", dim: "var(--text-sub)",
  bgUp: "rgba(240,68,82,", bgDn: "rgba(49,130,246,",
};
export const mono = { fontFamily: "'DM Mono', monospace" };
export const dirColor = (up) => up ? C.up : C.down;
export const dirBg = (up, alpha) => (up ? C.bgUp : C.bgDn) + alpha + ")";

// ─── 공유 포맷 함수 ───
export const fmtPct = (n) => n == null ? "-" : (n >= 0 ? "+" : "") + parseFloat(n).toFixed(2) + "%";
export const fmtPrice = (n) => n == null ? "-" : Math.round(n).toLocaleString("ko-KR");
export const fmtKRW = (n) => n == null ? "-" : Math.round(n).toLocaleString("ko-KR") + "원";
export const fmtVol = (n) => {
  if (!n) return "-";
  if (n >= 100000000) return (n / 100000000).toFixed(1) + "억";
  if (n >= 10000) return (n / 10000).toFixed(0) + "만";
  return n.toLocaleString();
};

// ─── AI 응답 호환 헬퍼 ───
export const ai = (obj, ...keys) => { for (const k of keys) { if (obj?.[k] != null) return obj[k]; } return null; };

// ─── 공유 fetch 래퍼 ───
export const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

export const fetchJson = async (path, fallback = null) => {
  try {
    const res = await fetch(`${BASE_URL}${path}`);
    return res.ok ? await res.json() : fallback;
  } catch { return fallback; }
};
